<template>
  <img src="/images/promo/connect-features/banker-award.svg" alt="Banker Awards" />
</template>

<script>
export default {};
</script>

